var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.$vuetify.breakpoint.md || _vm.$vuetify.breakpoint.lg || _vm.$vuetify.breakpoint.xl
  )?_c('v-parallax',{attrs:{"dark":"","src":require('@/assets/img/splash-cropped-min-v2.jpg'),"height":"500"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }